import { Directive, ElementRef, inject, input, DestroyRef, afterNextRender } from '@angular/core';
import { FocusMonitor } from '@angular/cdk/a11y';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FocusService } from './focus.service';

import type { FocusOrigin } from '@angular/cdk/a11y';
import type { InputSignalWithTransform } from '@angular/core';

@Directive({
  selector: '[tdWbFocusOnDisabled]'
})
export class FocusOnDisabledDirective {
  readonly focusOnDisabledElement: InputSignalWithTransform<ElementRef | undefined, ElementRef | string> = input<ElementRef | undefined, ElementRef | string>(undefined, {
    alias: 'tdWbFocusOnDisabled',
    transform: (value: ElementRef | string) => (value === '' ? undefined : value as ElementRef)
  });

  private readonly elementRef = inject(ElementRef);
  private readonly focusMonitor = inject(FocusMonitor);
  private readonly focusService = inject(FocusService);
  private readonly destroyRef = inject(DestroyRef);

  constructor() {
    this.destroyRef.onDestroy(() => {
      this.focusMonitor.stopMonitoring(this.elementRef);
    });

    afterNextRender(() => {
      this.focusMonitor
        .monitor(this.elementRef.nativeElement)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((origin: FocusOrigin): void => {
          const target = this.focusOnDisabledElement();
          if (origin === null && this.focusService.isDisabled(this.elementRef.nativeElement) &&
            target?.nativeElement !== undefined) {
            this.focusService.shiftFocus(target.nativeElement);
          }
        });
    });
  }
}
